import { render, staticRenderFns } from "./CustomerStandardForm.vue?vue&type=template&id=70123156"
import script from "./CustomerStandardForm.vue?vue&type=script&lang=ts"
export * from "./CustomerStandardForm.vue?vue&type=script&lang=ts"
import style0 from "./CustomerStandardForm.vue?vue&type=style&index=0&id=70123156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports